import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Dialog, IconButton } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { getAssetsBaseUrl } from '../../../config/assetsUrl';

interface GalleryProps {
    limit?: number;
}

const getImageTimestamp = (name: string): number => {
    const match = name.match(/(\d{4})-(\d{2})-(\d{2}) at (\d{2})\.(\d{2})\.(\d{2})/);
    if (!match) return 0;

    const [, year, month, day, hours, minutes, seconds] = match;
    return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours),
        Number(minutes),
        Number(seconds)
    ).getTime();
};

const galleryImages = [
    "WhatsApp Image 2026-02-02 at 21.14.36 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.14.36 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.14.36.jpeg",
    "WhatsApp Image 2026-02-02 at 21.14.37.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.21 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.21.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.22 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.22.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.26.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.32.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.33 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.33.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.34.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.36.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.38.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.39.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.42.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.43 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.43.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.44.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.46 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.46 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.46.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.49 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.49.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.50 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.50.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.55 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.55.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.56.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.58 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.58.jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.59 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.16.59 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.00 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.01 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.01 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.02 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.02.jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.03 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.03.jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.04 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.05 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.05.jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.06 (1).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.06.jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.07 (2).jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.07.jpeg",
    "WhatsApp Image 2026-02-02 at 21.17.08 (1).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.48 (1).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.48 (2).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.48 (3).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.48.jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.49 (1).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.49 (2).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.49 (3).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.49.jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.50 (1).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.50 (2).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.50 (3).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.50 (4).jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.50.jpeg",
    "WhatsApp Image 2026-04-22 at 23.08.51.jpeg",
];

const Gallery: React.FC<GalleryProps> = ({ limit }) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const allImages = useMemo(
        () =>
            [...galleryImages]
                .sort((a, b) => {
                    const dateDiff = getImageTimestamp(b) - getImageTimestamp(a);
                    if (dateDiff !== 0) return dateDiff;
                    return a.localeCompare(b);
                })
                .map((name) => ({
                    name,
                    src: `${getAssetsBaseUrl()}/images/gallery/${encodeURIComponent(name)}`,
                })),
        []
    );
    const images = useMemo(
        () => (limit ? allImages.slice(0, limit) : allImages),
        [allImages, limit]
    );

    const handleClose = () => setActiveIndex(null);
    const handlePrev = () => {
        if (activeIndex === null) return;
        setActiveIndex((activeIndex - 1 + images.length) % images.length);
    };
    const handleNext = () => {
        if (activeIndex === null) return;
        setActiveIndex((activeIndex + 1) % images.length);
    };

    useEffect(() => {
        if (activeIndex === null) return;
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'ArrowLeft') handlePrev();
            if (event.key === 'ArrowRight') handleNext();
            if (event.key === 'Escape') handleClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [activeIndex, images.length]);

    return (
        <>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(3, 1fr)',
                        md: 'repeat(4, 1fr)',
                    },
                    gap: { xs: 1, sm: 2 },
                }}
            >
                {images.map((image, index) => (
                    <Box
                        key={image.name}
                        onClick={() => setActiveIndex(index)}
                        sx={{
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: 2,
                            cursor: 'pointer',
                            backgroundColor: 'rgba(0,0,0,0.05)',
                            aspectRatio: '1 / 1',
                            transition: 'transform 0.25s ease',
                            '&:hover img': {
                                transform: 'scale(1.04)',
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={image.src}
                            alt={image.name}
                            loading="lazy"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block',
                                transition: 'transform 0.25s ease',
                            }}
                        />
                    </Box>
                ))}
            </Box>

            <Dialog
                open={activeIndex !== null}
                onClose={handleClose}
                fullScreen
                PaperProps={{
                    sx: {
                        backgroundColor: 'rgba(0,0,0,0.95)',
                        boxShadow: 'none',
                    },
                }}
            >
                {activeIndex !== null && (
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                            p: { xs: 2, sm: 3 },
                        }}
                    >
                        <IconButton
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                top: 12,
                                right: 12,
                                color: '#fff',
                                backgroundColor: 'rgba(0,0,0,0.4)',
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <IconButton
                            onClick={handlePrev}
                            sx={{
                                position: 'absolute',
                                left: { xs: 8, md: 20 },
                                color: '#fff',
                                backgroundColor: 'rgba(0,0,0,0.4)',
                            }}
                        >
                            <ChevronLeftIcon />
                        </IconButton>

                        <Box
                            component="img"
                            src={images[activeIndex].src}
                            alt={images[activeIndex].name}
                            sx={{
                                maxWidth: '96vw',
                                maxHeight: '92vh',
                                objectFit: 'contain',
                                borderRadius: 1,
                            }}
                        />

                        <IconButton
                            onClick={handleNext}
                            sx={{
                                position: 'absolute',
                                right: { xs: 8, md: 20 },
                                color: '#fff',
                                backgroundColor: 'rgba(0,0,0,0.4)',
                            }}
                        >
                            <ChevronRightIcon />
                        </IconButton>
                    </Box>
                )}
            </Dialog>
        </>
    );
};

export default Gallery;
